module.exports = __webpack_public_path__ + "assets/img/cddd9dce47028ea61d0a7adc94a28a11.png";